const quotationChat = {
  quotationChatNavLabel: "Trò chuyện báo giá", // translated 
  quotationChatApprovalTitle: "Trò chuyện báo giá", // translated 
  quotationChatAccountNotApprovedTitle: "Tài khoản chưa được duyệt", // translated 
  quotationChatAccountNotApprovedDescription:
    "Tài khoản của bạn chưa được phê duyệt. Vui lòng liên hệ với người quản lý tài khoản của bạn để biết thêm thông tin.", // translated 
  quotationChatViewAiChat: "Xem cuộc trò chuyện AI", // translated 

  quotationRequestChatSessions: "Phiên trò chuyện", // translated 
  quotationRequestChatNoPastSessions: "Không có phiên nào trước đó", // translated 
  quotationRequestChatNewChat: "Trò chuyện mới", // translated 
  quotationRequestChatCloseSidebar: "Đóng thanh bên", // translated 
  quotationRequestChatSessionFallback: "Phiên trò chuyện", // translated 
  quotationRequestChatDefaultSessionName: "Phiên trò chuyện mới", // translated 
  quotationRequestChatTitle: "Yêu cầu báo giá Trò chuyện", // translated 
  quotationRequestChatResponseLanguageLabel: "Ngôn ngữ phản hồi", // translated 
  quotationRequestChatOpenSidebar: "Mở thanh bên", // translated 
  quotationRequestChatRenameSession: "Đổi tên phiên", // translated 
  quotationRequestChatDeleteSession: "Xóa phiên", // translated 
  quotationRequestChatToggleDarkMode: "Bật/tắt chế độ tối", // translated 
  quotationRequestChatSwitchToLightMode: "Chuyển sang chế độ sáng", // translated 
  quotationRequestChatSwitchToDarkMode: "Chuyển sang chế độ tối", // translated 
  quotationRequestChatEmptyStateHeading: "Bắt đầu cuộc trò chuyện yêu cầu báo giá mới", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Hãy mô tả nhu cầu du lịch của bạn và tôi sẽ tạo yêu cầu báo giá cho bạn.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Nhập tin nhắn của bạn để bắt đầu cuộc trò chuyện... (Nhấn Shift + Enter để xuống dòng)", // translated 
  quotationRequestChatMessagePlaceholder: "Nhập tin nhắn của bạn... (Nhấn Shift + Enter để xuống dòng)", // translated 
  quotationRequestChatUploadFile: "Tải lên tệp", // translated 
  quotationRequestChatUploadAttachment: "Tải tệp đính kèm lên", // translated 

  quotationRequestChatStopGenerating: "Ngừng tạo", // translated 
  quotationRequestChatGenerateQuotation: "Tạo báo giá", // translated 
  quotationRequestChatGenerateFinalQuotation: "Tạo báo giá cuối cùng", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Hoàn tất yêu cầu báo giá", // translated 
  quotationRequestChatHoldToRecord: "Giữ để ghi âm tin nhắn thoại", // translated 
  quotationRequestChatRecordingReleaseToSend: "Ghi âm, phát hành để gửi", // translated 
  quotationRequestChatRecording: "Đang ghi âm...", // translated 
  quotationRequestChatSelectSessionFirst: "Vui lòng chọn phiên trò chuyện trước.", // translated 
  quotationRequestChatCancelVoiceRecording: "Hủy ghi âm giọng nói", // translated 
  quotationRequestChatListening: "Đang nghe...", // translated 
  quotationRequestChatTranscribing: "Đang phiên âm...", // translated 

  quotationRequestChatFileUploadedSuccess: "Tệp đã được tải lên thành công.", // translated 
  quotationRequestChatFailedCreateSession: "Không thể tạo phiên trò chuyện. Vui lòng thử lại.", // translated 
  quotationRequestChatFailedUploadFile: "Tải tệp lên không thành công. Vui lòng thử lại.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Vui lòng trả lời các câu hỏi còn tồn đọng trước khi gửi tin nhắn khác.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Vui lòng trả lời các câu hỏi còn tồn đọng trước khi hoàn tất yêu cầu báo giá.", // translated 
  quotationRequestChatFavoriteMarked: "Phiên trò chuyện được đánh dấu là yêu thích", // translated 
  quotationRequestChatFavoriteUnmarked: "Phiên trò chuyện chưa được đánh dấu là yêu thích", // translated 
  quotationRequestChatFailedSetFavorite: "Không thể đặt làm mục yêu thích", // translated 
  quotationRequestChatFailedUnsetFavorite: "Không thể bỏ chọn mục yêu thích", // translated 
  quotationRequestChatRenamedSuccess: "Phiên trò chuyện đã được đổi tên thành công.", // translated 
  quotationRequestChatFailedRename: "Không thể đổi tên phiên trò chuyện. Vui lòng thử lại.", // translated 
  quotationRequestChatDeletedSuccess: "Phiên trò chuyện đã được xóa thành công.", // translated 
  quotationRequestChatFailedDelete: "Không thể xóa phiên trò chuyện. Vui lòng thử lại.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Tệp đính kèm đã được xóa thành công.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Không thể xóa tệp đính kèm. Vui lòng thử lại.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Yêu cầu báo giá đã được gửi thành công! Yêu cầu của bạn đang được xử lý.", // translated 
  quotationRequestChatFailedSubmit: "Không thể gửi yêu cầu báo giá.", // translated 
  quotationChatPdfDownloadedSuccess: "Tệp PDF đã được tải xuống thành công!", // translated 
  quotationChatFailedGeneratePdf: "Không thể tạo tệp PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Vui lòng chọn người dùng đại lý phụ trước khi gửi yêu cầu báo giá.", // translated 
  quotationRequestChatAppUserLoading:
    "Hồ sơ người dùng ứng dụng CRM của bạn vẫn đang tải. Vui lòng thử lại sau một lát.", // translated 
  quotationRequestChatAppUserMismatch:
    "Hồ sơ người dùng ứng dụng CRM của bạn không khớp với phiên trò chuyện này.", // translated 

  quotationRequestChatRenameTitle: "Đổi tên phiên trò chuyện", // translated 
  quotationRequestChatSessionName: "Tên phiên", // translated 
  quotationRequestChatEnterSessionName: "Nhập tên phiên", // translated 
  quotationRequestChatSaving: "Đang lưu...", // translated 
  quotationRequestChatSave: "Cứu", // translated 
  quotationRequestChatDeleteTitle: "Xóa phiên trò chuyện", // translated 
  quotationRequestChatDeleteConfirm: "Bạn có chắc chắn muốn xóa phiên trò chuyện này không?", // translated 
  quotationRequestChatDeleteCannotUndo: "Hành động này không thể đảo ngược.", // translated 
  quotationRequestChatDeleting: "Đang xóa...", // translated 
  quotationRequestChatDelete: "Xóa bỏ", // translated 

  quotationRequestChatAttachmentsTitle: "Yêu cầu báo giá | Trò chuyện | Tệp đính kèm", // translated 
  quotationRequestChatLoadingAttachments: "Đang tải tệp đính kèm...", // translated 
  quotationRequestChatNoAttachments: "Không tìm thấy tệp đính kèm nào.", // translated 
  quotationRequestChatDeleteAttachment: "Xóa tệp đính kèm", // translated 
  quotationRequestChatUploadingAttachment: "Đang tải tệp đính kèm...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Vui lòng chờ trong khi tệp của bạn đang được tải lên.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Trả lời các câu hỏi đang chờ xử lý", // translated 
  quotationRequestChatProposeOwnAnswer: "Đề xuất câu trả lời của riêng tôi", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Hãy tự viết câu trả lời của bạn...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} trong tổng số {{total}} câu trả lời", // translated 
  quotationRequestChatReadyToSubmit: "Sẵn sàng nộp", // translated 
  quotationRequestChatSubmitAll: "Gửi tất cả", // translated 
  quotationRequestChatRespondToOneQuestion: "Trả lời câu hỏi {{count}}", // translated 
  quotationRequestChatRespondToManyQuestions: "Trả lời {{count}} câu hỏi", // translated 

  quotationRequestChatFinalizeTitle: "Hoàn tất yêu cầu báo giá", // translated 
  quotationRequestChatLoadingSessionData: "Đang tải dữ liệu phiên...", // translated 
  quotationRequestChatErrorLoadingSession: "Lỗi khi tải dữ liệu phiên. Vui lòng thử lại.", // translated 
  quotationRequestChatQuotationTitle: "Tiêu đề trích dẫn", // translated 
  quotationRequestChatExtraComments: "Bình luận bổ sung", // translated 
  quotationRequestChatSubmitting: "Đang gửi...", // translated 
  quotationRequestChatSubmit: "Nộp", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Đang gửi yêu cầu báo giá...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Vui lòng chờ trong khi yêu cầu báo giá của bạn đang được xử lý.", // translated 

  quotationRequestChatSelectSubagent: "Chọn đại lý phụ", // translated 
  quotationRequestChatSearchSubagents: "Tìm kiếm đại lý phụ...", // translated 
  quotationRequestChatLoadingSubagents: "Đang tải các tác nhân phụ...", // translated 
  quotationRequestChatNoSubagentsFound: "Không tìm thấy tác nhân phụ nào.", // translated 
  quotationRequestChatNoSubagentsAvailable: "Hiện không có đại lý phụ nào.", // translated 
  quotationRequestChatSelectedSubagent: "Đã chọn: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Người dùng đại lý phụ", // translated 
  quotationRequestChatSearchUsers: "Tìm kiếm người dùng...", // translated 
  quotationRequestChatNoUsersFound: "Không tìm thấy người dùng nào", // translated 
  quotationRequestChatNoUsersAvailable: "Hiện không có người dùng nào.", // translated 

  quotationChatDownloadSummaryTitle: "Tải xuống bản tóm tắt báo giá của bạn", // translated 
  quotationChatDownloadSummaryDescription:
    "Hãy điền thông tin của bạn bên dưới để tạo bản tóm tắt PDF cá nhân hóa về báo giá chuyến đi của bạn. Bản PDF sẽ bao gồm tất cả chi tiết chuyến đi, điểm đến, thông tin phương tiện di chuyển và lịch trình từng ngày.", // translated 
  quotationChatCustomerTitle: "Tiêu đề", // translated 
  quotationChatSelectTitle: "Chọn tiêu đề", // translated 
  quotationChatHonorificMr: "Ông", // translated 
  quotationChatHonorificMrs: "Bà", // translated 
  quotationChatHonorificMs: "Bệnh đa xơ cứng.", // translated 
  quotationChatHonorificDr: "Tiến sĩ", // translated 
  quotationChatHonorificProf: "Giáo sư", // translated 
  quotationChatCustomerPhone: "Điện thoại", // translated 
  quotationChatCustomerCompany: "Công ty", // translated 
  quotationChatCustomerMessage: "Tin nhắn", // translated 
  quotationChatCustomerCountry: "Quốc gia", // translated 
  quotationChatGenerating: "Đang tạo...", // translated 
  quotationChatDownloadPdf: "Tải xuống PDF", // translated 

  quotationChatTripSummary: "Tóm tắt chuyến đi", // translated 
  quotationChatDownloadAsPdf: "Tải xuống dưới dạng PDF", // translated 
  quotationChatNoTripSummary: "Không có bản tóm tắt chuyến đi nào cho phiên này.", // translated 

  quotationRequestChatThinking: "Đang suy nghĩ...", // translated 
  quotationRequestChatSources: "Nguồn", // translated 
  quotationRequestChatSearchingWebFor: 'Tìm kiếm trên web cho: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Các dịch vụ được thực hiện bởi nhà điều hành tour du lịch", // translated 
  quotationRequestChatServicesByCustomer: "Các dịch vụ do khách hàng cung cấp", // translated 
  quotationRequestChatReadyNotice:
    "Giờ đây, bạn có thể tạo báo giá cho yêu cầu này bằng cách nhấp vào nút bên phải.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Tạo báo giá cuối cùng", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Có lẽ bạn muốn hỏi:", // translated 
  quotationRequestChatClickToSendSuggestion: "Nhấp chuột để gửi tin nhắn này", // translated 

  quotationRequestChatAddToFavorites: "Thêm vào mục yêu thích", // translated 
  quotationRequestChatRemoveFromFavorites: "Xóa khỏi mục yêu thích", // translated 
  quotationRequestChatSubmitted: "Đã gửi", // translated 

  quotationRequestChatQuotationRequest: "Yêu cầu báo giá: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{tiêu đề}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Trạng thái: {{status}}", // translated 

  quotationChatLoading: "Đang tải...", // translated 
  quotationChatSessionNotFound: "Không tìm thấy phiên trò chuyện cho báo giá này.", // translated 
  quotationChatMemberSessionNotFound: "Không tìm thấy phiên thành viên cho tài khoản của bạn.", // translated 
  quotationChatUnableToConnect: "Không thể kết nối với cuộc trò chuyện", // translated 
  quotationChatConnecting: "Đang kết nối...", // translated 
  quotationChatTypeYourMessage: "Nhập tin nhắn của bạn...", // translated 
  quotationChatConnected: "Đã kết nối", // translated 
  quotationChatConnectingStatus: "Đang kết nối...", // translated 
  quotationChatDisconnected: "Đã ngắt kết nối", // translated 
};


export default quotationChat;
